import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=a2e0f4fc&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"
import style0 from "./partners.vue?vue&type=style&index=0&id=a2e0f4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e0f4fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgArrowRight: require('/app/components/svg/ArrowRight.vue').default,AnimBottomToTop: require('/app/components/AnimBottomToTop.vue').default})
